import {Layout} from 'antd'
import * as React from 'react'
import {useEffect, useState} from 'react'
import {Redirect, Route, Switch} from 'react-router'
import DspList from 'src/component/app/dsp/DspList'
import {NotFound} from 'src/component/app/NotFound'
import PublisherCreate from 'src/component/app/publisher/PublisherCreate'
import PublisherEdit from 'src/component/app/publisher/PublisherEdit'
import {PublisherList} from 'src/component/app/publisher/PublisherList'
import {menuData} from 'src/component/app/sidebar/menuData'
import {useUser} from 'src/context/UserContext'
import {isAdmin, isAuthenticated, isDsp, isPublisher, isReporting, setLoggedUserProps} from '../../util/Util'
import '../root/common.css'
import AccountCreate from './account/AccountCreate'
import AccountEdit from './account/AccountEdit'
import AccountList from './account/AccountList'
import {Breadcrumb} from './breadcrumb/Breadcrumb'
import DspCreate from './dsp/DspCreate'
import HouseAdSizeCreate from './houseAdSize/HouseAdSizeCreate'
import {HouseAdSizeEdit} from './houseAdSize/HouseAdSizeEdit'
import HouseAdSizeList from './houseAdSize/HouseAdSizeList'
import HouseCreativeCreate from './houseCreative/HouseCreativeCreate'
import {HouseCreativeEdit} from './houseCreative/HouseCreativeEdit'
import HouseCreativeList from './houseCreative/HouseCreativeList'
import {RawReport} from './rawReports/RawReport'
import {DspReport as DspReport} from './reports/DspReport'
import {PublisherReport as PublisherReport} from './reports/PublisherReport'
import {Sidebar} from './sidebar/Sidebar'
import {AccountBean} from '../../api/api';
import {AdminDashboardByPublisher} from './dashboard/adminDashboard/byPublisher/AdminDashboardByPublisher';
import {Validation} from './validation/Validation';
import {PublisherDashboard} from './dashboard/publisherDashboard/PublisherDashboard';
import {DspDashboard} from './dashboard/dspDashboard/DspDashboard';
import DealCreate from './deal/DealCreate'
import DealList from './deal/DealList'
import {DealEdit} from './deal/DealEdit'
import NodeCreate from './node/NodeCreate';
import NodeEdit from './node/NodeEdit';
import NodeList from './node/NodeList';
import DspEdit from './dsp/DspEdit';
import ScheduledReportList from './scheduledReport/ScheduledReportList';
import {ScheduledReportEdit} from './scheduledReport/ScheduledReportEdit';
import RoleEnum = AccountBean.RoleEnum;
import TestRequest from './request/TestRequest'
import {RequestResponseIds} from './reports/RequestResponseIds';
import {RejectionReason} from './reports/RejectionReason';
import {AdminDashboardByDsp} from './dashboard/adminDashboard/byDsp/AdminDashboardByDsp';
import SOVTemplateList from './sovTemplate/SOVTemplateList'
import SOVTemplateCreate from './sovTemplate/SOVTemplateCreate'
import { SOVTemplateEdit } from './sovTemplate/SOVTemplateEdit'
import Navbar from './navbar/Navbar'
import DomainFilterLayout from './domainFilter/DomainFilterLayout'
import { LatestPublisherDashboard } from './dashboard/latestPublisherDashboard/PublisherDashboard'
import { ReportsDashboard } from './reports/ReportsDashboard'

const { Content } = Layout;

const AntContent = Layout.Content;

export const App: React.FC = () => {
  const { user, setUser } = useUser();

  const [selectedMenuKeys, setSelectedMenuKeys] = useState([""]);
  const [openMenuKeys, setOpenMenuKeys] = useState([""]);

  useEffect(() => {
    if (isAuthenticated()) {
      setLoggedUserProps(setUser);
    }
  }, []);

  useEffect(() => {
    if (user) {
      let selectedKey = location.pathname.substring(1);
      if (selectedKey === "dashboard") {
        switch (user.role) {
          case AccountBean.RoleEnum.Publisher:
            selectedKey = "dashboard";
            break;
          case AccountBean.RoleEnum.Dsp:
            selectedKey = "dashboard";
            break;
          case AccountBean.RoleEnum.Admin:
            selectedKey = "dashboardByPublisher";
            break;
        }
      }

      setOpenMenuKeys([getParentMenuKey(selectedKey)]);
      setSelectedMenuKeys([selectedKey]);
    }

    if (user?.role === "Publisher") {
      document.body.className = "bg-[#0b0b0b]";
    }else{
      document.body.className = "bg-[#f2f4f8]";
    }
    document.cookie = "_ga=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.alkimi.org";
  }, [user]);

  const getParentMenuKey = (pathName: string) => {
    // @ts-ignore
    let find = menuData.find(
      (item) =>
        item.children &&
        item.children.some((childItem) => pathName.includes(childItem.key))
    );
    return find != undefined ? find.key : "";
  };

  const handleMenuClick = (param) => {
    setSelectedMenuKeys([param.key]);
  };

  const onOpenMenuChange = (openKeys) => {
    setOpenMenuKeys(openKeys);
  };

  const admin = isAdmin(user);
  const publisher = isPublisher(user);
  const dsp = isDsp(user);
  const reporting = isReporting(user);

  if (!isAuthenticated()) return <Redirect to={"/login"} />;

  if (!user) return null;

  return isAuthenticated() ? (
    <>
      {publisher ? (
        <>
          <Navbar>
            <DomainFilterLayout>
            <Route path="/dashboard" component={LatestPublisherDashboard} />
            <Route path="/report" component={ReportsDashboard} />
            </DomainFilterLayout>
          </Navbar>

        </>
      ) : (
        <Layout>
          <Sidebar
            openKeys={openMenuKeys}
            selectedKeys={selectedMenuKeys}
            onOpenChange={onOpenMenuChange}
            handleClick={handleMenuClick}
          />
          <Layout>
            <AntContent style={{ height: "100%" }}>
              <div className="utils__content">
                <Breadcrumb />
                <Content
                  style={{
                    margin: "0 -20px",
                    padding: 24,
                    background: "#fff",
                    minHeight: 280,
                  }}
                >
                  <Switch>
                    <Route
                      path="/dashboard"
                      component={
                        admin || reporting
                          ? AdminDashboardByPublisher
                          : publisher
                          ? PublisherDashboard
                          : DspDashboard
                      }
                    />
                    <Route
                      path="/dashboardByPublisher"
                      component={AdminDashboardByPublisher}
                    />
                    <Route
                      path="/dashboardByDsp"
                      component={AdminDashboardByDsp}
                    />

                    <Route
                      path="/account/create"
                      component={admin ? AccountCreate : NotFound}
                    />
                    <Route path="/account/:id/edit" component={AccountEdit} />
                    <Route
                      path="/account"
                      component={admin ? AccountList : NotFound}
                    />

                    <Route
                      path="/node/create"
                      component={admin ? NodeCreate : NotFound}
                    />
                    <Route path="/node/:id/edit" component={NodeEdit} />
                    <Route
                      path="/node"
                      component={admin ? NodeList : NotFound}
                    />

                    <Route
                      path="/publishers/create"
                      component={admin ? PublisherCreate : NotFound}
                    />
                    <Route
                      path="/publishers/:id/edit"
                      component={admin ? PublisherEdit : NotFound}
                    />
                    <Route
                      path="/publishers"
                      component={admin ? PublisherList : NotFound}
                    />

                    <Route
                      path="/dsp/create"
                      component={admin ? DspCreate : NotFound}
                    />
                    <Route
                      path="/dsp/:id/edit"
                      component={admin ? DspEdit : NotFound}
                    />
                    <Route path="/dsp" component={admin ? DspList : NotFound} />

                    <Route
                      path="/mini-exchange/create"
                      render={() =>
                        admin ? <DspCreate miniExchange={true} /> : <NotFound />
                      }
                    />
                    <Route
                      path="/mini-exchange/:id/edit"
                      render={() =>
                        admin ? <DspEdit miniExchange={true} /> : <NotFound />
                      }
                    />
                    <Route
                      path="/mini-exchange"
                      render={() => <DspList miniExchange={true} />}
                    />

                    <Route
                      path="/house-ad-size/create"
                      component={admin ? HouseAdSizeCreate : NotFound}
                    />
                    <Route
                      path="/house-ad-size/:id/edit"
                      component={admin ? HouseAdSizeEdit : NotFound}
                    />
                    <Route
                      path="/house-ad-size"
                      component={admin ? HouseAdSizeList : NotFound}
                    />

                    <Route
                      path="/house-creative/create"
                      component={admin ? HouseCreativeCreate : NotFound}
                    />
                    <Route
                      path="/house-creative/:id/edit"
                      component={admin ? HouseCreativeEdit : NotFound}
                    />
                    <Route
                      path="/house-creative"
                      component={admin ? HouseCreativeList : NotFound}
                    />

                    <Route
                      path="/deal/create"
                      component={admin ? DealCreate : NotFound}
                    />
                    <Route
                      path="/deal/:id/edit"
                      component={admin ? DealEdit : NotFound}
                    />
                    <Route
                      path="/deal"
                      component={admin ? DealList : NotFound}
                    />

                    <Route
                      path="/reportPublisher"
                      component={
                        admin || reporting || publisher
                          ? PublisherReport
                          : NotFound
                      }
                    />
                    <Route
                      path="/reportDsp"
                      component={
                        admin || reporting || dsp ? DspReport : NotFound
                      }
                    />
                    <Route
                      path="/requestResponseIds"
                      component={RequestResponseIds}
                    />
                    <Route
                      path="/rejectionReason"
                      component={admin || reporting ? RejectionReason : NotFound}
                    />
                                <Route path="/sov-template/create" component={admin ? SOVTemplateCreate : NotFound} />
                                <Route path="/sov-template/:id/edit" component={admin ? SOVTemplateEdit : NotFound} />
                                <Route path="/sov-template" component={admin ? SOVTemplateList : NotFound} />


                    <Route
                      path="/raw-report"
                      component={admin ? RawReport : NotFound}
                    />

                    <Route
                      path="/scheduled-report/:id/edit"
                      component={ScheduledReportEdit}
                    />
                    <Route
                      path="/scheduled-report"
                      component={ScheduledReportList}
                    />

                    <Route
                      path="/validation"
                      component={
                        admin || reporting || publisher || dsp
                          ? Validation
                          : NotFound
                      }
                    />
                    <Route
                      path="/request"
                      component={admin ? TestRequest : NotFound}
                    />
                  </Switch>
                </Content>
              </div>
            </AntContent>
          </Layout>
        </Layout>
      )}
       {/* <Redirect from="/" to={"/dashboard"} /> */}

    </>
  ) : (
    <Redirect to={"/login"} />
  );
};
